export default "__VITE_ASSET__Dk1VBZZk__"